import { getAppProps } from '@/AppProps';
import { perfLog } from '@kibt/krn-utils';
import queryString from 'query-string';
import { NativeModules } from 'react-native';
import { getKrnDomain } from './api';
import { radar } from './log';

/** 记录性能耗时 */
let onCreateTimeStamp = 0;
let t1 = 0;
let t2 = 0;
let t3 = 0;

// 记录当前是那个路由
let pageUrl = '';
let componentName = '';

export function resetSPACreateTimestamp(_componentName = '', params = {}) {
    const { rootTag } = getAppProps();
    onCreateTimeStamp = Date.now();
    t1 = 0;
    t2 = 0;
    t3 = 0;
    // 构建url
    pageUrl = queryString.stringifyUrl({
        url: `${getKrnDomain()}/krn-web/spa-bundle`,
        query: {
            ...params,
            redirectUrl: `bundleId=EcommSpaBundle&componentName=${_componentName}`,
        },
    });
    componentName = _componentName;
    // 重置时间
    NativeModules?.RootViewPageBridge?.resetPageRenderTimeParamsWith?.(rootTag, { onCreateTimeStamp });
    radar.event({
        name: 'SPA_Navigate_Start',
        params: {
            componentName: _componentName,
            query: params,
        },
    });
    console.log(`【SPA性能】重置T0时间, onCreateTimestamp: ${onCreateTimeStamp}, rootTag: ${rootTag}, pageUrl: ${pageUrl}`);
    console.log(
        `【SPA性能】重置T0时间, typeof resetPageRenderTimeParamsWith: ${typeof NativeModules.RootViewPageBridge?.resetPageRenderTimeParamsWith}`
    );
}

// 上报T1
export function whiteScreen() {
    // 判断是否从Spa应用跳转过来的
    const { rootTag } = getAppProps();
    if (pageUrl) {
        t1 = Date.now();
        NativeModules?.RootViewPageBridge?.rootViewDidMountWith?.(rootTag, {
            bundleId: 'EcommSpaBundle',
            componentName,
            page: 'EcommSpaBundle',
            pageURL: pageUrl,
        });
        console.log(
            `【SPA性能】T1耗时: ${t1 - onCreateTimeStamp}, rootTag: ${rootTag}, params: ${JSON.stringify({
                pageShow: {
                    page: 'EcommSpaBundle',
                    bundleId: 'EcommSpaBundle',
                    componentName,
                    pageURL: pageUrl,
                },
            })}`
        );
        console.log(`【SPA性能】T1耗时, typeof rootViewDidMountWith: ${typeof NativeModules.RootViewPageBridge?.rootViewDidMountWith}`);
    } else {
        perfLog.whiteScreen();
    }
}

// 上报T2
export function firstAPI() {
    const { rootTag } = getAppProps();
    // 判断是否从Spa应用跳转过来的
    if (pageUrl) {
        t2 = Date.now();
        console.log(`【SPA性能】T2耗时: ${t2 - t1}, rootTag: ${rootTag}`);
    } else {
        perfLog.firstAPI();
    }
}

// 上报T3
export function firstScreen() {
    // 判断是否从Spa应用跳转过来的
    const { rootTag } = getAppProps();
    if (pageUrl) {
        t3 = Date.now();
        const t2Duration = t2 - onCreateTimeStamp;
        const t3Duration = t3 - onCreateTimeStamp;
        NativeModules?.RootViewPageBridge?.reportPageRenderTime?.(rootTag, t2Duration, t3Duration, {
            page: 'EcommSpaBundle',
            bundleId: 'EcommSpaBundle',
            componentName,
            pageURL: pageUrl,
        });
        console.log(
            `【SPA性能】T3耗时, t2: ${t2Duration}, t3: ${t3Duration}, rootTag: ${rootTag}, params: ${JSON.stringify({
                pageShow: {
                    page: 'EcommSpaBundle',
                    bundleId: 'EcommSpaBundle',
                    componentName,
                    pageURL: pageUrl,
                },
            })}`
        );
        console.log(`【SPA性能】T3耗时, typeof reportPageRenderTime: ${typeof NativeModules.RootViewPageBridge?.reportPageRenderTime}`);
    } else {
        perfLog.firstScreen();
    }
}
